export default [
  {
    name: "Nils Holger, HS",
    id: "5f792ac2-cdd0-49fa-8ba5-9c5a039f19f6",
  },
  {
    name: "Flöjten",
    id: "95e67ad5-a942-4fe3-94c6-30d3c697af36",
  },
  {
    name: "Trumpeten",
    id: "6bdac943-5a8e-467f-82f4-2e2b5e73d571",
  },
  {
    name: "Valthornet",
    id: "f1ed938a-b633-4333-a6aa-4e9997bceca2",
  },
  {
    name: "Klarinetten",
    id: "57084b7d-90ed-4725-8fce-e680f00a69d3",
  },
  {
    name: "Trombonen",
    id: "d009a911-0129-4294-8295-4f7656f4844e",
  },
]; /* .map(({ name, id }) => ({
  name,
  id,
  locationId: locations.campusUS.house462.id
}))
 */
